import { Button } from '@dixa/lib-shared-habla';

import { useAppNavigate } from 'utils/url/useAppNavigate';

export function BackToFormsListingButton(): JSX.Element {
  const navigate = useAppNavigate();

  const navigateToFormsList = () => {
    navigate({ path: '/settings/custom-forms' });
  };

  return (
    <Button icon="arrow-left" variant="tertiary" onClick={navigateToFormsList}>
      All forms
    </Button>
  );
}
